import { useAuthStore } from '../store/auth.store';

/**
 * [AB#185 / ADR-030, uso corrigido no AB#295] Hook que devolve a unidade preferida do
 * usuário logado (`estabelecimento_preferencial_id`) ou `null` se não houver.
 *
 * [CLAUDE.md "Frontend — Filtro de estabelecimento"] Consumido INTERNAMENTE por
 * `SeletorEstabelecimento` — a página NÃO chama este hook direto. Regressão histórica
 * (AB#295): `AutomacoesPage`/`CampanhasPage` chamavam `useEstabPreferencial()` no
 * `useState` inicial da própria página, mas inicializavam ANTES do componente montar,
 * então abriam em "Todos" por engano. Corrigido movendo a aplicação do preferencial pra
 * dentro do `SeletorEstabelecimento` (aplica uma vez no mount, quando `value=null`) — a
 * página só precisa `useState<number | null>(null)` e passar `value`/`onChange`.
 *
 * Single-unit é resolvido pelo `SeletorEstabelecimento` (que retorna null + dispara
 * onChange com o id único); este hook devolve o que o backend mandou — geralmente `null`
 * em single-unit, porque escolher preferencial entre 1 não faz sentido.
 */
export function useEstabPreferencial(): number | null {
  return (
    useAuthStore((s) => s.usuario?.estabelecimento_preferencial_id) ?? null
  );
}
